# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/
$(document).on 'turbolinks:load', ->
  $("#del_datum").datepicker({ language: 'cs-CZ', dateFormat: "yy-mm-dd" })
  $("#fb").fancybox
    scrolling: "no"
    titleShow: false
    onClosed: ->
      $("#login_error").hide()

  $("#form_report").submit (event) ->
    event.preventDefault()
    #text = $("#text").val()
    #console.log( $( "#form_report :input" ).serializeArray() );
    #event.preventDefault();
    $.ajax
      type: "POST"
      cache: false
      url: "/products/report"
      data: $("#form_report :input").serializeArray()
      success: (data) ->
        $.fancybox data
    false

  $("#doprava_cb").click ->
    $("#doprava").toggleClass("skryte")
    $("#nedoprava").toggleClass("skryte")
    
  if $("#product_delivery_id option:selected").val() isnt ""
    $("#doprava").toggleClass "skryte"
    $("#nedoprava").toggleClass "skryte"
    $("#doprava_cb").attr "checked", not $("#chk").is(":checked")
    
  $("form.submit_on_change").each (idx, form) ->
    $(form).find("select,input").each (idx, element) ->
      if $(element).is("select[multiple]")
        # u multiselectu odešli až po zavření dropdownu, ne po každém zaškrtnutí
        $(element).on "hidden.bs.select", ->
          $(form).submit()
          false
      else
        $(element).change ->
          $(form).submit()
          false

  # enable chosen js — destroy first to prevent double-init on Turbolinks cache restore
  $('.chosen-select').chosen('destroy')
  $('.chosen-select').chosen
    allow_single_deselect: true
    no_results_text: 'No results matched'
    width: '200px'

  # inject dark mode styles for chosen widget after it initializes
  if window.matchMedia('(prefers-color-scheme: dark)').matches and not document.getElementById('chosen-dark-mode')
    style = document.createElement('style')
    style.id = 'chosen-dark-mode'
    style.textContent = """
      .chosen-container-multi .chosen-choices { background-color: #242424 !important; background-image: none !important; border-color: #3a3a3a !important; color: #e8e8e8 !important; }
      .chosen-container-multi .chosen-choices li.search-field input[type="text"] { background: #242424 !important; color: #e8e8e8 !important; }
      .chosen-container-multi .chosen-choices li.search-choice { background: #3a3a3a !important; background-image: none !important; border-color: #555 !important; color: #e8e8e8 !important; }
      .chosen-container-multi .chosen-choices li.search-choice span { color: #e8e8e8 !important; }
      .chosen-container-multi .chosen-choices li.search-choice .search-choice-close { filter: invert(1); }
      .chosen-container .chosen-drop { background-color: #242424 !important; border-color: #3a3a3a !important; }
      .chosen-container .chosen-results li { color: #e8e8e8 !important; }
      .chosen-container .chosen-results li.highlighted { background-color: #007bff !important; color: #fff !important; }
    """
    document.head.appendChild(style)

  $(".inlinesparklinegraph").sparkline "html",
    type: "bar"
    #barColor: "blue"
    tooltipSuffix: " pcs"

  $("nav.pagy-bootstrap-nav ul.pagination").addClass("pagination-sm")

  document.addEventListener 'keydown', (event) ->
    if event.altKey and event.key == 'p'
      event.preventDefault()
      document.getElementById('product_position_ids').focus()
    return
  document.addEventListener 'keydown', (event) ->
  if event.ctrlKey and event.key == 'b'
    event.preventDefault()
    # Zabraňte normálnímu chování Ctrl+B (např. otevření záložky)
    element = document.querySelector('.chosen-search-input.default')
    if element
      element.focus()
  return
  document.addEventListener 'keydown', (event) ->
  if event.ctrlKey and event.key == 'e'
    event.preventDefault()
    # Zabraňte normálnímu chování Ctrl+B (např. otevření záložky)
    element = document.getElementById('product_weight')
    if element
      element.focus()
  return


